import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=30bee009&scoped=true&"
import script from "./Voting.vue?vue&type=script&lang=js&"
export * from "./Voting.vue?vue&type=script&lang=js&"
import style0 from "./Voting.vue?vue&type=style&index=0&id=30bee009&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bee009",
  null
  
)

export default component.exports